module.exports = __webpack_public_path__ + "assets/heart_eyes.85f35801a7a0511495d30a39d24904e5.png";